import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import resources from '../../services'
import Btn from '../../ui/Btn'
import { Field } from '../../ui/Field'
import UpdatePage from '../../composents/UpdatePage'

const title = 'Settings'
const headers = {
  icon: 'feather icon-edit',
  title,
  description: 'update of setting',
  breadcrumbs: [
    {
      title,
      link: '/settings',
    },
  ],
}

export default function EditSetting() {
  const [loader, setLoader] = useState(false),
    [data, setData] = useState({}),
    [errors, setErrors] = useState({}),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    { id } = useParams()

  async function onGet() {
    setLoading(true)
    let res = await resources.setting
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      setData(res.data)
    } else if (res.status === 403) {
      setFail(true)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [id])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onUpdate(e) {
    e.preventDefault()
    setLoader(true)
    setErrors({})
    let formData = new FormData(e.target)
    let object = Object.fromEntries(formData)
    object.name = data.name

    let res = await resources.setting
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/settings')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
    >
      <form onSubmit={onUpdate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <Field
                  name="name"
                  className="mb-3"
                  error={errors['name']}
                  defaultValue={data?.name}
                  required
                  disabled
                >
                  Name
                </Field>

                <Field
                  name="value"
                  className="mb-3"
                  error={errors['value']}
                  defaultValue={data?.value}
                  required
                >
                  Value
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
